<template>
  <div class="eating">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import { setupWXShare } from '@/helpers'
import { loadScript } from '@/load.js'
export default {
  name: 'Eating',
  data() {
    return {
    }
  },
  created () {
    setTimeout(() => {
      this.initWxShare()
    }, 500)

    // 悬浮球下载
    loadScript()
  },
  methods: {
    async initWxShare() {
      const host = `${location.protocol}//${location.hostname}${location.pathname}#/eating`
      setupWXShare({
        title: "能不能吃",
        desc: "查一查能不能吃的食物分类",
        link: host,
        imgUrl: "https://888.doctopia.com.cn/addons/ewei_shopv2/plugin/article/static/images/nbnc/icon-4.png",
        type: 'link',
        dataUrl: ''
      })
    }
  }
}

</script>
<style lang='scss'>
.eating {
  background-color: #fff;
  min-height: 100vh;
}
</style>
